import React from 'react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.3,
      ease: "easeIn"
    }
  }
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const headerVariants = {
  hidden: {
    opacity: 0,
    y: -20,
    scale: 0.98
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      delay: 0.1
    }
  }
};

const metricsVariants = {
  hidden: {
    opacity: 0,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut",
      staggerChildren: 0.1,
      delayChildren: 0.3
    }
  }
};

const chartVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: "easeOut",
      delay: 0.5
    }
  }
};

const DashboardTransition = ({ children }) => {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="w-full h-full"
    >
      {children}
    </motion.div>
  );
};

// Componentes auxiliares para diferentes seções do dashboard
export const DashboardHeader = ({ children }) => (
  <motion.div variants={headerVariants}>
    {children}
  </motion.div>
);

export const DashboardMetrics = ({ children }) => (
  <motion.div variants={metricsVariants}>
    {children}
  </motion.div>
);

export const DashboardMetricCard = ({ children }) => (
  <motion.div 
    variants={itemVariants}
    whileHover={{ 
      scale: 1.02,
      y: -2,
      transition: { duration: 0.2 }
    }}
  >
    {children}
  </motion.div>
);

export const DashboardCharts = ({ children }) => (
  <motion.div variants={chartVariants}>
    {children}
  </motion.div>
);

export const DashboardChart = ({ children }) => (
  <motion.div 
    variants={itemVariants}
    whileHover={{ 
      scale: 1.01,
      transition: { duration: 0.2 }
    }}
  >
    {children}
  </motion.div>
);

export default DashboardTransition;